import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useParams, Redirect } from "react-router-dom";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import MdlSelectEventParticipatingStudent from "../dialog/MdlSelectEventParticipatingStudent";
import BackButton from "../ChildComponent/BackButton";

const PrintableDocsEvent = () => {
  const { document_type } = useParams();
  const [loggedIn] = useState(localStorage.getItem("token") !== null);
  const [loading, setLoading] = useState(false);
  const [isOpenSelectStudent, setIsOpenSelectStudent] = useState(false);
  const [showStudentIdCard, setShowStudentIdCard] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [printableSamples, setPrintableSamples] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [height, setHeight] = useState("800px");
  const [selectedSampleId, setSelectedSampleId] = useState("");
  const [selectedSamplePosition, setSelectedSamplePosition] = useState(0);
  const [selectedColorPosition, setSelectedColorPosition] = useState(0);
  const [selectionType, setSelectionType] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileDirectory, setFileDirectory] = useState("");
  const [colorOptionId, setColorOptionId] = useState("");
  const [eventList, setEventList] = useState([]);
  const [eventId, setEventId] = useState("");

  const docType = document_type || "";

  const handleMessage = useCallback((event) => {
    if (event.data?.iframeHeight) {
      setHeight(`${event.data.iframeHeight}px`);
    }
  }, []);

  const handleCloseSelectStudent = useCallback(() => {
    setIsOpenSelectStudent(false);
  }, []);

  const handleSelectedStudent = useCallback((selectedStudentsList) => {
    const students = selectedStudentsList || [];
    setIsOpenSelectStudent(false);
    setShowStudentIdCard(true);
    setSelectedStudents(students);
    setSelectionType("student");
  }, []);

  const selectStudent = useCallback(() => {
    setIsOpenSelectStudent(true);
  }, []);

  const buildFileUrl = useCallback((file_name, file_directory, sample_id, event_id, studentList = selectedStudents) => {
    if (!file_directory || !file_name || !sample_id || !event_id) {
      return null;
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    let session_id = "";
    const studentIds = [];

    if (selectionType === "student" && studentList.length > 0) {
      studentList.forEach((student) => {
        if (student.paricipant_id) {
          studentIds.push(student.paricipant_id);
          if (!session_id && student.session_id) {
            session_id = student.session_id;
          }
        }
      });
    }

    const params = new URLSearchParams({
      student_ids: JSON.stringify(studentIds),
      class_id: "",
      section_id: "",
      session_id: session_id,
      sample_id: sample_id,
      selection_type: selectionType,
      system_code: process.env.REACT_APP_SYSTEM_CODE || "",
      color_option_id: colorOptionId,
      event_id: event_id,
      school_code: SCHOOL_CODE,
    });

    const url = `${process.env.REACT_APP_SERVER_NAME}${file_directory}${file_name}?${params.toString()}`;
    
    console.log("=== Event Pass URL ===");
    console.log("Full URL:", url);
    console.log("Parameters:", {
      student_ids: studentIds,
      session_id: session_id,
      sample_id: sample_id,
      selection_type: selectionType,
      color_option_id: colorOptionId,
      event_id: event_id,
      school_code: SCHOOL_CODE,
      file_directory: file_directory,
      file_name: file_name,
    });
    console.log("=====================");
    
    return url;
  }, [selectedStudents, selectionType, colorOptionId]);

  const updateFileUrl = useCallback(() => {
    if (!fileDirectory || !fileName || !selectedSampleId || !eventId) {
      console.log("updateFileUrl: Missing required values", {
        fileDirectory,
        fileName,
        selectedSampleId,
        eventId,
      });
      return;
    }

    const url = buildFileUrl(fileName, fileDirectory, selectedSampleId, eventId);
    if (url) {
      console.log("updateFileUrl: Setting file URL", url);
      setFileUrl(url);
    } else {
      console.warn("updateFileUrl: buildFileUrl returned null");
    }
  }, [fileName, fileDirectory, selectedSampleId, eventId, buildFileUrl]);

  const getEventList = useCallback(() => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const session = SessionManager.getCurrentSession();
    
    if (!session || !session[0]?.session_id) {
      setLoading(false);
      myToast.notify_warning("Session not found");
      return;
    }

    const SESSION_ID = session[0].session_id;
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getEventList.php`;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          session_id: SESSION_ID,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK" && Array.isArray(response.data) && response.data.length > 0) {
          setEventList(response.data);
          setEventId(response.data[0].event_id);
        } else {
          setEventList([]);
          myToast.notify_warning(response.api_remark || "No events found for this session");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching event list:", error);
        myToast.notify_error("Error loading events. Please try again.");
        setEventList([]);
      });
  }, []);

  const getPrintableSamples = useCallback(() => {
    if (!docType) {
      console.warn("Document type is missing");
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getPrintableSample.php`;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          document_type: docType,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK" && Array.isArray(response.data) && response.data.length > 0) {
          setPrintableSamples(response.data);
          // Set first sample after state update
          setTimeout(() => {
            const sample = response.data[0];
            if (sample) {
              setFileName(sample.file_name || "");
              setFileDirectory(sample.file_directory || "");
              setSelectedSampleId(sample.sample_id || "");
              getColorOptions(0, response.data);
            }
          }, 100);
        } else {
          myToast.notify_warning(response.api_remark || "No printable samples found");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error loading printable samples:", error);
        myToast.notify_error("Error loading printable samples");
      });
  }, [docType]);

  const getColorOptions = useCallback((samplePosition, samples = printableSamples) => {
    if (!samples || samples.length === 0 || samplePosition >= samples.length) return;

    const colorOptionsList = samples[samplePosition]?.color_options || [];
    setColorOptions(colorOptionsList);
    setColorOptionId(colorOptionsList[0]?.color_option_id || "");
  }, [printableSamples]);

  const setSample = useCallback((samplePosition, samples = printableSamples) => {
    if (!samples || samples.length === 0 || samplePosition >= samples.length) {
      return;
    }

    const sample = samples[samplePosition];
    const { sample_id, file_name, file_directory } = sample;

    setFileName(file_name || "");
    setFileDirectory(file_directory || "");
    setSelectedSampleId(sample_id || "");

    setTimeout(() => {
      getColorOptions(samplePosition, samples);
    }, 100);
  }, [printableSamples, getColorOptions]);

  const changeColor = useCallback((index) => {
    setSelectedColorPosition(index);
    setShowStudentIdCard(true);
    if (colorOptions[index]?.color_option_id) {
      setColorOptionId(colorOptions[index].color_option_id);
    }
  }, [colorOptions]);

  const changeSample = useCallback((position) => {
    setSelectedSamplePosition(position);
    setSample(position);
  }, [setSample]);

  const handleChangeEvent = useCallback((e) => {
    setEventId(e.target.value);
  }, []);

  // Load data on component mount
  useEffect(() => {
    window.addEventListener("message", handleMessage, false);
    
    if (docType) {
      getPrintableSamples();
      getEventList();
    } else {
      myToast.notify_warning("Document type is missing. Please check the URL.");
    }

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [docType, getPrintableSamples, getEventList, handleMessage]);

  // Update file URL when dependencies change
  useEffect(() => {
    updateFileUrl();
  }, [selectedSampleId, selectedColorPosition, eventId, selectionType, fileDirectory, fileName, colorOptionId, selectedStudents, updateFileUrl]);

  // Update file URL when students are selected
  useEffect(() => {
    if (selectedStudents.length > 0 && selectionType === "student") {
      updateFileUrl();
    }
  }, [selectedStudents, selectionType, updateFileUrl]);

  const documentCaption = useMemo(() => {
    return printableSamples.length > 0 
      ? `Printable-${printableSamples[0].document_caption}` 
      : "Printable";
  }, [printableSamples]);

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (loading) {
    return <MyLoader />;
  }

  return (
    <div className="content" style={{ background: "#f8fafc", minHeight: "100vh" }}>
      <div
        className="content-header"
        style={{ 
          background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#1e40af"} 100%)`,
          boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
        }}
      >
        <div
          className="leftside-content-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#" style={{ color: COLORS.white }}>{documentCaption}</a>
            </li>
          </ul>
          <BackButton
            onClick={() => window.history.back()}
            style={{
              height: "28px",
              fontSize: "13px",
              padding: "2px 6px",
              marginTop: "0px",
            }}
          />
        </div>
      </div>

      <div
        className="animated fadeInUpn"
        style={{ 
          margin: "12px",
          background: COLORS.white,
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
          padding: "16px",
        }}
      >
        {/* Action Buttons Section */}
        <div style={{ 
          display: "grid", 
          gridTemplateColumns: "1fr 1fr", 
          gap: "12px",
          marginBottom: "16px",
        }}>
          <button
            onClick={selectStudent}
            style={{
              padding: "10px 16px",
              borderRadius: "10px",
              border: "none",
              background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#1e40af"} 100%)`,
              color: "#fff",
              fontWeight: 600,
              fontSize: "16px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 6px 16px rgba(59, 130, 246, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.3)";
            }}
          >
            <i className="fa fa-users" />
            Select Students Manually
          </button>

          <div style={{
            padding: "10px 14px",
            borderRadius: "10px",
            background: COLORS.white,
            border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}>
            <div style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#1e40af"} 100%)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: "18px",
            }}>
              <i className="fa fa-calendar" />
            </div>
            <div style={{ 
              flex: 1,
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}>
              <label style={{ 
                fontSize: "15px", 
                color: COLORS.black8, 
                fontWeight: 600,
                whiteSpace: "nowrap",
              }}>
                Select Event:
              </label>
              {eventList.length > 0 ? (
                <select
                  onChange={handleChangeEvent}
                  value={eventId}
                  style={{
                    flex: 1,
                    padding: "6px 10px",
                    borderRadius: "8px",
                    border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                    fontSize: "15px",
                    fontWeight: 500,
                    color: COLORS.black8,
                    background: COLORS.white,
                    cursor: "pointer",
                    outline: "none",
                    transition: "all 0.3s ease",
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = COLORS.primary_color_shade6;
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = COLORS.grey3;
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  {eventList.map((item) => (
                    <option key={item.event_id} value={item.event_id}>
                      {item.event_name}
                    </option>
                  ))}
                </select>
              ) : (
                <div
                  style={{
                    flex: 1,
                    padding: "8px 10px",
                    background: "#fef3c7",
                    borderRadius: "8px",
                    color: "#92400e",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <i className="fa fa-exclamation-triangle" />
                  No events available
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Sample List */}
        {printableSamples.length > 1 && (
          <div style={{ marginBottom: "16px" }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "12px",
            }}>
              <div style={{
                width: "3px",
                height: "20px",
                borderRadius: "2px",
                background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#1e40af"} 100%)`,
              }} />
              <h5 style={{ 
                margin: 0, 
                fontSize: "18px", 
                fontWeight: 600,
                color: COLORS.black8,
              }}>
                Sample List
              </h5>
            </div>
            <div style={{
              display: "flex",
              gap: "12px",
              overflowX: "auto",
              padding: "12px",
              background: "#f8fafc",
              borderRadius: "10px",
            }}>
              {printableSamples.map((item, index) => (
                <div
                  key={item.sample_id || index}
                  onClick={() => changeSample(index)}
                  style={{
                    minWidth: "120px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <div
                    style={{
                      background: COLORS.white,
                      borderRadius: "10px",
                      padding: "10px",
                      boxShadow: selectedSamplePosition === index
                        ? `0 6px 20px rgba(59, 130, 246, 0.3), 0 0 0 3px ${COLORS.primary_color_shade6}`
                        : "0 2px 8px rgba(0, 0, 0, 0.08)",
                      border: selectedSamplePosition === index
                        ? `3px solid ${COLORS.primary_color_shade6}`
                        : "2px solid transparent",
                      transition: "all 0.3s ease",
                      height: "110px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img 
                      src={item.sample_img} 
                      alt={item.sample_name}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <div style={{
                    textAlign: "center",
                    marginTop: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: COLORS.black8,
                  }}>
                    {item.sample_name}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Color Options */}
        {colorOptions.length > 1 && (
          <div style={{ marginBottom: "16px" }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "12px",
            }}>
              <div style={{
                width: "3px",
                height: "20px",
                borderRadius: "2px",
                background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#1e40af"} 100%)`,
              }} />
              <h5 style={{ 
                margin: 0, 
                fontSize: "18px", 
                fontWeight: 600,
                color: COLORS.black8,
              }}>
                Color Options
              </h5>
            </div>
            <div style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              padding: "12px",
              background: "#f8fafc",
              borderRadius: "10px",
            }}>
              {colorOptions.map((item, index) => {
                const [color1, color2] = (item.sample_color_code || "").split("_");
                return (
                  <div
                    key={item.color_option_id || index}
                    onClick={() => changeColor(index)}
                    style={{
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <div
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "10px",
                        overflow: "hidden",
                        boxShadow: selectedColorPosition === index
                          ? `0 6px 20px rgba(59, 130, 246, 0.3), 0 0 0 3px ${COLORS.primary_color_shade6}`
                          : "0 2px 8px rgba(0, 0, 0, 0.08)",
                        border: selectedColorPosition === index
                          ? `3px solid ${COLORS.primary_color_shade6}`
                          : "2px solid transparent",
                        transition: "all 0.3s ease",
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: color1 || "#ccc",
                          flex: 1,
                        }}
                      />
                      <div
                        style={{
                          backgroundColor: color2 || "#ccc",
                          flex: 1,
                        }}
                      />
                    </div>
                    {item.sample_color_name && (
                      <div style={{
                        textAlign: "center",
                        marginTop: "6px",
                        fontSize: "13px",
                        fontWeight: 500,
                        color: COLORS.black8,
                      }}>
                        {item.sample_color_name}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Preview Section */}
        <div>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "12px",
          }}>
            <div style={{
              width: "3px",
              height: "20px",
              borderRadius: "2px",
              background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#1e40af"} 100%)`,
            }} />
            <h5 style={{ 
              margin: 0, 
              fontSize: "18px", 
              fontWeight: 600,
              color: COLORS.black8,
            }}>
              Preview
            </h5>
          </div>

          <div style={{
            background: COLORS.white,
            borderRadius: "10px",
            padding: "12px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            border: `1px solid ${COLORS.grey3 || "#E0E0E0"}`,
            position: "relative",
            minHeight: "300px",
          }}>
            {showStudentIdCard && (
              <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(255, 255, 255, 0.9)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "10px",
                zIndex: 10,
              }}>
                <MyLoader />
              </div>
            )}
            <Iframe
              url={fileUrl}
              width="100%"
              height={height}
              style={{ 
                border: "none", 
                overflow: "hidden",
                borderRadius: "8px",
              }}
              id="iFrame1"
              scrolling="no"
              display="initial"
              position="relative"
              onLoad={() => setShowStudentIdCard(false)}
            />
          </div>
        </div>
      </div>

      {isOpenSelectStudent && (
        <MdlSelectEventParticipatingStudent
          actionClose={handleCloseSelectStudent}
          actionHandleSelected={handleSelectedStudent}
          event_id={eventId}
        />
      )}
    </div>
  );
};

export default PrintableDocsEvent;

